import React from "react";
import { mapEdgesToNodes } from "../lib/helpers";
import { CardGrid } from "./card/card-grid";
import { SectionWrapper } from "./sections";
import { LogoBox } from "./sections/logos";
import { ImageBuilder } from "./global/image-builder";
import PortableText from "./portableText";

const AVATAR_SIZE = 96;

export const AuthorPage = ({ doc, posts }) => (
  <>
    <SectionWrapper padding="top" container="thin">
      <div className="flex items-start gap-6 mb-8">
        {doc.image?.asset && (
          <ImageBuilder
            image={doc.image}
            width={AVATAR_SIZE}
            height={AVATAR_SIZE}
            className="rounded-full shrink-0"
            alt={doc.name}
          />
        )}
        <div>
          <h1 className="text-3xl font-bold mb-2">{doc.name}</h1>
          <p className="text-xs text-secondary uppercase">Writing As</p>
          {(doc.title || doc.companies?.[0]) && (
            <p className="text-secondary flex items-center gap-2">
              <span>
                {doc.title}
                {doc.title && doc.companies?.[0] && ", "}
                {doc.companies?.[0]?.title}
              </span>
              {doc.companies?.[0]?.mainImage && (
                <LogoBox
                  image={doc.companies[0].mainImage}
                  maxHeight={24}
                  left={true}
                  alt={doc.companies[0].title}
                />
              )}
            </p>
          )}

          {(doc.twitter || doc.linkedin) && (
            <div className="flex gap-4 mt-2 text-sm">
              {doc.twitter && (
                <a
                  href={`https://twitter.com/${doc.twitter}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link hover:underline"
                >
                  @{doc.twitter}
                </a>
              )}
              {doc.linkedin && (
                <a
                  href={doc.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link hover:underline"
                >
                  View LinkedIn
                </a>
              )}
            </div>
          )}
        </div>
      </div>
      {doc._rawBio && (
        <div className="mb-8 prose">
          <PortableText blocks={doc._rawBio} />
        </div>
      )}
    </SectionWrapper>

    <SectionWrapper padding="bottom" container="thin">
      <CardGrid
        nodes={mapEdgesToNodes(posts).filter((p) => p.slug)}
        showSubTags={true}
        showByline={false}
        browseMoreHref="/blog/"
        maxColumns={2}
        allowSummary={true}
        showSummary={true}
        panels={true}
        attribution={{ action: "suggestion", label: "post" }}
        makeThumbnail={true}
        hideType={true}
      />
    </SectionWrapper>
  </>
);
